import { useMemo } from 'react';
import { useParams } from 'react-router';
import { ApiKeysPermissions, ConnectPermission, TaskPermissions } from '@connect-x-app/shared-domain-models';

import { useGetRole, useUpdateRole } from '../../../../queries';

const filterPermissions = (permissions: Set<ConnectPermission>, permissionsToRemove: string[]): Set<ConnectPermission> => {
  return new Set(Array.from(permissions).filter(permission => !permissionsToRemove.includes(permission)));
};

export const usePermissions = () => {
  const { roleId } = useParams();
  const { data: role, isLoading: isDataLoading } = useGetRole(roleId ?? '');
  const { isPending: IsUpdateLoading, mutate } = useUpdateRole();

  // TaskPermissions.VIEW is filtered out because it is attached to the 'can be mentioned externally' instead of the
  // permissions
  const permissionsToRemove = useMemo(() => {
    return [...Object.values(ApiKeysPermissions), TaskPermissions.VIEW];
  }, []);

  const filteredPermissions = useMemo(() => {
    return filterPermissions(new Set(role?.permissions), permissionsToRemove);
  }, [role?.permissions, permissionsToRemove]);

  return {
    isLoading: isDataLoading || IsUpdateLoading,
    permissions: filteredPermissions,
    updatePermissions: (permissions: Set<ConnectPermission>) => {
      const updatedPermissions = filterPermissions(permissions, permissionsToRemove);
      if (role) {
        mutate({
          ...role,
          permissions: Array.from(updatedPermissions),
        });
      }
    },
  };
};
